import type React from 'react';
import { URL_ERP_PORTAL } from '@/shared/config';
import { ConfirmModal } from '@/shared/ui';
import './authenticationGate.s.scss';
import FrontEndMonitoring from './frontEndMonitoring/frontEndMonitoring';
import NetWorkState from './networkState';
import useAuthenticationGate from './useAuthenticationGate';

export type AuthenticationGateProps = {
  children: React.ReactNode;
};

/**
 * Withholds the application until the session is resolved, and handles expiry and portal login. Renders the children with front-end monitoring only once state.isLoadedData, shows a session-expired confirm modal that signs the user out, always mounts the network state banner, and embeds the ERP portal iframe when auth mode is known and the user did not log in with a username.
 *
 * @param children - The application tree rendered once the session has loaded.
 * @returns The rendered gate wrapping the children with its modals and portal iframe.
 */
const AuthenticationGate = ({ children }: AuthenticationGateProps) => {
  const { state, onLoad, signOutEvent } = useAuthenticationGate();

  return (
    <>
      {state.isLoadedData && (
        <>
          {children}
          <FrontEndMonitoring />
        </>
      )}
      <ConfirmModal
        isOpen={state.isShowModalExpriedToken}
        onClickRightButton={() => {
          signOutEvent();
        }}
        rightButtonName="OK"
        title="Session expired"
        question="Your session has expired. You need to login again."
      />
      <NetWorkState />
      {state.isCheckedAuthMode && !state.isLoggedInWithUsername && (
        <iframe
          id="iframe-id"
          className="erp-portal-iframe"
          src={URL_ERP_PORTAL}
          title="ERP Portal"
          onLoad={onLoad}
        />
      )}
    </>
  );
};

export default AuthenticationGate;
